import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from 'src/app/constants';
import { AccountActivationComponent } from './account-activation.component';

const routes: Routes = [
	{ path: ROUTES.ROOT, component: AccountActivationComponent }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})

export class AccountActivationRoutingModule { }
